import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  projectGroupPath,
  projectPath,
} from '../../../../cross-team-shared/hub-paths';
import { Project } from '../../../../team-apis/otterdam/project';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-navigation-breadcrumbs',
  templateUrl: './navigation-breadcrumbs.component.html',
  styleUrls: ['./navigation-breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavigationBreadcrumbsComponent {
  @Input() stepId?: number;
  project$: Observable<Project>;
  step$: Observable<string>;
  buildProjectGroupPath = projectGroupPath;
  buildProjectPath = projectPath;
  projectGroupLabel$: Observable<string>;

  constructor(store: TaskWorkspaceStore) {
    this.project$ = store('project').$;
    this.projectGroupLabel$ = this.project$.pipe(
      map(
        (project) =>
          project.project_group_name +
          (project.project_group_workflow_code
            ? ` (${project.project_group_workflow_code})`
            : ''),
      ),
    );

    this.step$ = store('project')('steps').$.pipe(
      filter(() => !!this.stepId),
      map(
        (steps) =>
          `Step ${steps.find((s) => s.id === this.stepId)?.ordinal_letter}`,
      ),
    );
  }
}
